export enum SessionErrorEnum {
  REFRESH_ACCESS_TOKEN_ERROR = "RefreshAccessTokenError",
}
